<template>
  <div class="major-plan-detail">
    <!-- 头部区域 -->
    <div class="plan-header" v-if="showBack">
      <a href="javascript:void(0)" class="back-link" @click="handleBack"> <em style="position: relative;top: -1px;">&lt;</em> 返回 </a>
      <p class="plan-title">{{ majorPlan.title || `${majorPlan.code}-${majorPlan.name}` }}</p>
    </div>
    <p class="plan-title-center" v-else>{{ majorPlan.title || `${majorPlan.code}-${majorPlan.name}` }}</p>

    <!-- 内容区域 -->
    <div class="plan-content">
      <!-- 课程表格 -->
      <div class="course-table-container">
        <table class="course-table">
          <thead>
            <tr>
              <th class="col-index">序号</th>
              <th class="col-code">课程代码</th>
              <th class="col-name">课程名称</th>
              <th class="col-credit">学分</th>
              <th class="col-exam-type">考试类型</th>
              <th class="col-remark">备注</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(course, index) in courses" :key="index" :class="{ 'even-row': index % 2 === 0 }">
              <td 
                v-if="shouldShowIndex(course, index)" 
                class="col-index" 
                :rowspan="getIndexRowspan(course, index)"
              >{{ course.num }}</td>
              <td class="col-code">{{ course.code }}</td>
              <td class="col-name">{{ course.name }}</td>
              <td class="col-credit">{{ course.score }}</td>
              <td class="col-exam-type">{{ course.examType | f('examType') }}</td>
              <td 
                v-if="shouldShowRemark(course, index)" 
                class="col-remark" 
                :rowspan="getRemarkRowspan(course, index)"
              >
                {{ getMergedRemark(course, index) }}
              </td>
            </tr>
            <!-- 合计行 -->
            <tr class="total-row">
              <td class="total-label" colspan="2">合计</td>
              <td class="total-credits" colspan="4">{{ majorPlan.totalScore }}学分</td>
            </tr>
            <!-- 选考组行 -->
            <tr v-if="courseList.length > 0" class="elective-row">
              <td class="elective-cell" colspan="2">选考组</td>
              <td class="elective-courses" colspan="3">
                <span v-for="(course, index) in courseList" :key="index" class="elective-course">{{ course.code }} {{ course.name }} ({{ course.score }}学分)
                    <span v-if="index < courseList.length - 1">、</span>
                </span>
              </td>
              <td class="elective-remark" colspan="2">
                <span v-for="(course, index) in courseList" :key="index" class="elective-course" v-if="course.remark">{{ course.remark }}
                    <span v-if="index < courseList.length - 1">、</span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 底部操作区域 -->
    <div class="plan-footer">
      <button class="register-btn" @click="handleRegister">报名</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MajorPlanDetail',
  props: {
    specId: {
      type: String,
      default: ''
    },
    showBack: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
      courses: [],
      courseList: [], //选课组
      majorPlan:{}
    }
  },
  created() {
    this.loadMajorPlanData()
  },
  methods: {
    // 序号列：根据 num 相同合并，只在相同序号组的第一行显示
    shouldShowIndex(course, index) {
      if (index === 0) return true
      const prev = this.courses[index - 1]
      return prev && prev.num !== course.num
    },
    getIndexRowspan(course, index) {
      if (!this.shouldShowIndex(course, index)) return 1
      let count = 1
      for (let i = index + 1; i < this.courses.length; i++) {
        if (this.courses[i].num === course.num) count++
        else break
      }
      return count
    },
    // 备注列：根据 type 相同合并，只在相同类型组的第一行显示；type为0时不合并
    shouldShowRemark(course, index) {
      // type为0时，每行都显示备注，不合并
      if (course.type === 0) return true
      // 其他情况按type相同合并
      if (index === 0) return true
      const prev = this.courses[index - 1]
      return prev && prev.type !== course.type
    },
    getMergedRemark(course, index) {
      // 同一 type 组使用组内第一条的备注
      return course.remark || ''
    },
    getRemarkRowspan(course, index) {
      if (!this.shouldShowRemark(course, index)) return 1
      // type为0时，不合并，rowspan为1
      if (course.type === 0) return 1
      // 其他情况计算相同type的行数
      let count = 1
      for (let i = index + 1; i < this.courses.length; i++) {
        if (this.courses[i].type === course.type) count++
        else break
      }
      return count
    },
    handleBack() {
      this.$emit('back')
    },
    handleRegister() {
      this.$emit('register', this.majorPlan.id)
    },
    loadMajorPlanData() {
      console.log(this.specId)
      if(this.specId){
        this.$http.get(this.MOCK_PREFIX + '/student/pc/getSpecialtyList/'+this.specId+'?target_id=21849fb0f0705f').then(res => {
          if (res) {
            this.majorPlan = res || {}
            this.courseList = res.courseList || []
            this.courses = res.courses || []
          }
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.major-plan-detail {
  width: 100%;
}

.plan-header {
  position: relative;
  padding: 20px 30px 10px 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  .back-link {
    position: absolute;
    left: 30px;
    color: #767676;
    text-decoration: none;
    font-size: 14px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .plan-title {
    font-size: 24px;
    color: #1A1A1A;
    margin: 20px 0 0 0;
    text-align: center;
  }
}

.plan-title-center {
  text-align: center;
  font-size: 24px;
  color: #1A1A1A;
}

.plan-content {
  padding: 20px 30px;
  min-height: 400px;
}

.course-table-container {
  width: 100%;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.course-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  thead {
    background: #E9EFF9;

    th {
      padding: 10px 8px;
      text-align: center;
      font-weight: 500;
      color: #1A1A1A;
      border: 1px solid #DCDFE6;
    }
  }

  tbody {
    tr {
      background: #fff;

      &.even-row {
        background: #fff;
      }

      td {
        padding: 15px 8px;
        text-align: center;
        border: 1px solid #EBEEF5;
        color: #1A1A1A;
      }
    }

    .total-row {
      background: #fff;
      font-weight: 500;

      .total-label {
        text-align: center;
        padding-left: 20px;
      }

      .total-credits {
        font-weight: 600;
      }
    }

    .elective-row {
      background: #fff;

      .elective-cell {
        text-align: left;
        padding: 15px 20px;
        line-height: 1.8;

        .elective-label {
          font-weight: 500;
          margin-bottom: 8px;
        }

        .elective-courses {
          margin-bottom: 8px;
        }

        .elective-course {
          color: #1A1A1A;
        }

        .elective-remark {
          color: #666;
          font-size: 13px;
        }
      }
    }
  }
}

// 列宽设置
.col-index {
  width: 80px;
  min-width: 80px;
}

.col-code {
  width: 120px;
  min-width: 120px;
}

.col-name {
  width: 250px;
  min-width: 180px;
}

.col-credit {
  width: 100px;
  min-width: 80px;
}

.col-exam-type {
  width: 120px;
  min-width: 100px;
}

.col-remark {
  min-width: 200px;
}

.plan-footer {
  padding: 20px 30px 30px;
  display: flex;
  justify-content: center;
}

.register-btn {
  width: 160px;
  height: 40px;
  background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
  border-radius: 10px 10px 10px 10px;
  color: #fff;
  border: none;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(63, 107, 187, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
}
</style>
